/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownLeftIcon20Solid = forwardRef('ArrowDCornerDownLeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M15.25 10c0 .69-.56 1.25-1.25 1.25H4.768l3.366-3.366a1.25 1.25 0 0 0-1.768-1.768l-4.44 4.44a2.75 2.75 0 0 0 0 3.889l4.44 4.439a1.25 1.25 0 0 0 1.768-1.768L4.768 13.75H14A3.75 3.75 0 0 0 17.75 10V2.5a1.25 1.25 0 0 0-2.5 0V10Z" })));
});
